// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintSuggestionsStep-cls1_DVU","cls2":"PreprintSuggestionsStep-cls2_zhe PreprintSuggestionsStep-cls1_DVU"};